<template>
	<div>
		<TopBanner />

		<Header
			v-if="showsHeader"
			:type="headerType"
			@searchButtonClick="openFinder()"
			@titleClick="({ title }) => openFinder({ defaultKeyword: title })"
			@clearKeywordButtonClick="openFinder()"
		/>

		<Snb v-show="showsMenu" @close="closeMenu" />

		<QuickNavi v-if="showsQuickNavigator" @menuButtonClick="openMenu" />

		<!-- body 영역 -->
		<section class="ly_container">
			<router-view />
		</section>

		<Footer v-if="showsFooter" />

		<Fabs v-if="isHideFabs" />

		<!-- 검색 팝업 -->
		<SearchModal />

		<!-- 약관 동의 팝업 -->
		<TermsReAgreePopup />
	</div>
</template>

<script>
import TopBanner from '@/Layout/common/TopBanner.vue';
import Header from '@/Layout/common/Header';
import Snb from '@/Layout/common/Snb';
import Footer from '@/Layout/common/Footer';
import QuickNavi from '@/Layout/common/QuickNavi';
import Fabs from '@/Layout/common/Fabs';
import { mapGetters, mapActions } from 'vuex';
import SearchModal from '@/components/layerPop/SearchModal';
import TermsReAgreePopup from '@/components/layerPop/TermsReAgreePopup';
import sessionStore from '@/utils/sessionStore';
import AlarmMsg from '@/utils/alarmMsg';
import { getMktPopupYn, saveMarketingAgree } from '@/api/common/user';
import moment from 'moment';
import cpaMixins from '@/helpers/mixins/cpaMixins';

export default {
	name: 'layout',
	mixins: [cpaMixins],
	components: {
		Header,
		Snb,
		TopBanner,
		Footer,
		QuickNavi,
		Fabs,
		SearchModal,
		TermsReAgreePopup,
	},
	data() {
		return {
			isHideFabs: false,
		};
	},
	computed: {
		...mapGetters([
			'showsHeader',
			'headerType',
			'showsFooter',
			'footerType',
			'showsMenu',
			'showsQuickNavigator',
			'userInfo',
		]),
	},
	watch: {
		'userInfo.userStts': {
			deep: true,
			handler(value) {
				if (!value) return;
				this.chkMarketingAgree(); // 마케팅 수신동의 전체체크 미동의 고객 대상 팝업 노출
				sessionStore.remove('actionLogin'); // 로그인 하면 들어오는 액션 후처리 값 삭제
			},
		},
		$route(route) {
			const hidePathNameList = ['pick', 'pickDetail', 'pickFinish'];
			const routeName = route.name;

			this.isHideFabs = !hidePathNameList.includes(routeName);
		},
	},
	methods: {
		...mapActions(['openMenu', 'closeMenu']),
		...mapActions('finder', ['openFinder']),
		chkMarketingAgree() {
			if (!sessionStore.get('actionLogin')) return; // 로그인 직후 한번만 호출

			// 마케팅 미동의 고객 조회
			getMktPopupYn({ userNo: this.userInfo.userNo }).then(response => {
				if (response.code === 'SUC0000') {
					if (response.result.mktPopupYn === 'Y') {
						this.openMarketingPopup();
					}
				}
			});
		},
		openMarketingPopup() {
			if (this.userInfo.smsAgreeYn === 'N' || this.userInfo.mailingAgreeYn === 'N') {
				let type = '';
				if (this.userInfo.smsAgreeYn === 'N' && this.userInfo.mailingAgreeYn === 'N') {
					type = '이메일, 문자';
				} else {
					this.userInfo.smsAgreeYn === 'N' ? (type = '문자') : (type = '이메일');
				}
				let data = {
					userNo: this.userInfo.userNo,
					smsAgreeYn: this.userInfo.smsAgreeYn,
					mailingAgreeYn: this.userInfo.mailingAgreeYn,
				};
				AlarmMsg.showConfirm(
					'마케팅 수신(' +
						type +
						')에 동의 시 기프티쇼 비즈에서 제공하는 이벤트 혜택을 받으실 수 있습니다.<br> 동의하시겠습니까?',
					'마케팅 수신동의',
					'동의하고 혜택받기',
					'다음에 받기'
				)
					.then(() => {
						// 혜택받기
						data.smsAgreeYn = 'Y';
						data.mailingAgreeYn = 'Y';
						this.changeAlert('동의', type, data);
					})
					.catch(() => {
						// 다음에 받기
						this.changeAlert('거부', type, data);
					});
			}
		},
		changeAlert(msg, type, data) {
			// 마케팅 다음에 받기 날짜 or 수신동의 상태를 저장
			saveMarketingAgree(data)
				.then(response => {
					if (response.code === 'SUC0000') {
						const message = `전송 서비스: 기프티쇼 비즈
						<br>
						수신${msg}일시: ${moment().format('YYYY-MM-DD HH:mm')}
						<br>
						처리내용: 수신 ${msg} 완료
						<br>
						수신방법: ${type}
						<br><br>
						마이비즈 > 회원정보 관리에서 변경할 수 있습니다.
						`;

						AlarmMsg.showMsg(message, '기프티쇼 비즈 알림').then(() => {});
					} else {
						console.error('[saveMarketingAgree]', response);
					}
				})
				.catch(error => {
					console.error('[saveMarketingAgree]', error);
				});
		},
	},
	created() {
		// tenping load
		this.cpaTenpingLoad();
	},
};
</script>

<style></style>
